// extracted by mini-css-extract-plugin
export default {"Crumbs":"Crumbs_Crumbs__u+a+c","LinkText":"Crumbs_LinkText__tkhez","LinkTextLast":"Crumbs_LinkTextLast__yZo7Q"};